import React, { useState } from 'react';
import './JourneyAndStories.css';

export default function JourneyAndStories() {
  const [currentSlide, setCurrentSlide] = useState(0);

  const testimonials = [
    {
      id: 1,
      initial: 'R',
      name: 'Rajesh Kumar',
      role: 'MCA Graduate, 2023',
      text: '"The quality of education at CDOE is on par with regular colleges. The faculty is highly experienced and the support system helped me throughout my journey."'
    },
    {
      id: 2,
      initial: 'A',
      name: 'Anjali Sharma',
      role: 'MBA Graduate, 2024',
      text: '"Managing my job and studies was seamless thanks to their online portal. The study materials provided were comprehensive and highly practical."'
    },
    {
      id: 3,
      initial: 'S',
      name: 'Suresh Patel',
      role: 'BCom Graduate, 2022',
      text: '"Affordable fee structure combined with excellent digital learning resources made it possible for me to finish my degree without financial strain."'
    }
  ];

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev === testimonials.length - 1 ? 0 : prev + 1));
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev === 0 ? testimonials.length - 1 : prev - 1));
  };

  return (
    <div className="journey-stories-wrapper">
      
      {/* 1. Ready to Begin Your Journey Banner Block */}
      <section className="journey-banner">
        <div className="journey-container">
          <div className="journey-text-side">
            <h2>Ready to Begin Your Academic Journey?</h2>
            <p>Join 85,000+ students and transform your career with our distance education programs.</p>
          </div>
          <div className="journey-buttons-side">
            <a href="/enquiry" className="journey-btn btn-apply">Apply Now</a>
            <a href="/contact-enquiry" className="journey-btn btn-enquiry">Online Enquiry</a>
          </div>
        </div>
      </section>

      {/* 2. Student Stories Testimonials Block */}
      <section className="stories-section" id="student-stories">
        <div className="stories-container">
          
          <div className="stories-header">
            <span className="stories-tag">STUDENT STORIES</span>
            <h2 className="stories-title">What Our Students Say</h2>
          </div>

          {/* Testimonial Slider Wrapper */}
          <div className="testimonial-slider-box">
            <div className="quote-mark">“</div>
            
            <p className="testimonial-quote">
              {testimonials[currentSlide].text}
            </p>

            <div className="testimonial-user-row">
              <div className="avatar-circle">
                {testimonials[currentSlide].initial}
              </div>
              <div className="user-details-box">
                <h3>{testimonials[currentSlide].name}</h3>
                <p>{testimonials[currentSlide].role}</p>
              </div>
            </div>
          </div>

          {/* Slider Pagination Controls Elements */}
          <div className="slider-controls">
            <button className="arrow-control" onClick={prevSlide} aria-label="Previous story">‹</button>
            <div className="dots-container">
              {testimonials.map((_, index) => (
                <button
                  key={index}
                  className={`dot-indicator ${currentSlide === index ? 'dot-active' : ''}`}
                  onClick={() => setCurrentSlide(index)}
                  aria-label={`Go to slide ${index + 1}`}
                />
              ))}
            </div>
            <button className="arrow-control" onClick={nextSlide} aria-label="Next story">›</button>
          </div>

        </div>
      </section>

    </div>
  );
}